'use strict';
angular.module('schoolLinqApp').directive('localUseReportingSelector', localUseReportingSelectorController);

function localUseReportingSelectorController() {
	var controller = [
		'$scope',
		'localUseService',
		function (scope, localUseService) {
			scope.loadLocalUse = function () {
				scope.fields = [];
				scope.groups = [];
				scope.errors = [];

				localUseService.getEntityFields(scope.entityType).subscribe((response) => {
					if (response.isValid) {
						scope.fields = _.where(response.fields, { Active: true }); // only active fields
						// update any null group names to 'Misc.'
						_.forEach(scope.fields, function (field) {
							if (!field.GroupName) field.GroupName = 'Misc.';
							field.selected = scope.allSelected;
						});
						scope.groups = scope.getGroups();
					} else {
						scope.errors.push(response.error);
					}

					scope.getSelectedIds();
				});
			};

			scope.getGroups = function () {
				var groupNames = _.uniq(
					_.map(scope.fields, function (field) {
						return field.GroupName;
					})
				);

				var groups = [];
				_.forEach(groupNames, function (groupName) {
					var groupFields = scope.getGroupFields(groupName);
					groups.push({
						groupName: groupName,
						groupFields: groupFields,
						selected: scope.allSelected,
					});
				});

				return _.sortBy(groups, function (group) {
					return group.groupName.toLowerCase();
				});
			};

			scope.getGroupFields = function (groupName) {
				var groupFields = _.sortBy(
					_.filter(scope.fields, function (field) {
						return field.GroupName === groupName;
					}),
					'Priority'
				);
				return groupFields;
			};

			scope.allToggled = function () {
				_.forEach(scope.groups, function (group) {
					group.selected = scope.allSelected;
					_.forEach(group.groupFields, function (field) {
						field.selected = group.selected;
					});
				});
				scope.getSelectedIds();
			};

			scope.groupToggled = function (group) {
				_.forEach(group.groupFields, function (field) {
					field.selected = group.selected;
				});

				scope.getSelectedIds();
			};

			scope.fieldToggled = function (field, group) {
				if (field.selected) {
					group.selected = _.every(group.groupFields, function (field) {
						return field.selected;
					});
				} else {
					group.selected = false;
				}

				scope.getSelectedIds();
			};

			scope.getSelectedIds = function () {
				scope.selectedFieldIds = _.map(_.where(scope.fields, { selected: true }), function (field) {
					return field.Id;
				});
				scope.allSelected = scope.selectedFieldIds.length === scope.fields.length;

				return scope.selectedFieldIds;
			};
		},
	];

	return {
		restrict: 'E',
		scope: {
			entityType: '@', // type of entity
			allSelected: '=',
			selectedFieldIds: '=',
		},
		replace: true,
		template: require('@ajs/templates/localUseReportingSelector.html'),
		controller: controller,
		link: function (scope, element, attrs) {
			scope.loadLocalUse();
		},
	};
}
